import { API_BASE_URL } from '../config/settings';

export interface UploadResult {
  id: string;
  url: string;
}

class ImageService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = API_BASE_URL;
  }

  async uploadImage(file: File | Blob): Promise<UploadResult | null> {
    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await fetch(`${this.baseUrl}/images`, {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (result.success && result.data) {
        return {
          id: result.data.id,
          url: `${this.baseUrl}${result.data.url}`
        };
      }

      console.error('Image upload failed:', result.error);
      return null;
    } catch (error) {
      console.error('Image upload error:', error);
      return null;
    }
  }

  async uploadFromDataUrl(dataUrl: string): Promise<UploadResult | null> {
    // Convertir data URL a Blob
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    return this.uploadImage(blob);
  }

  async uploadFromClipboard(item: DataTransferItem): Promise<UploadResult | null> {
    const file = item.getAsFile();
    if (!file) return null;
    return this.uploadImage(file);
  }

  // Detectar si hay una imagen en el portapapeles
  hasImageInClipboard(clipboardData: DataTransfer): boolean {
    for (const item of Array.from(clipboardData.items)) {
      if (item.type.startsWith('image/')) {
        return true;
      }
    }
    return false;
  }

  // Obtener imagen del portapapeles
  getImageFromClipboard(clipboardData: DataTransfer): DataTransferItem | null {
    for (const item of Array.from(clipboardData.items)) {
      if (item.type.startsWith('image/')) {
        return item;
      }
    }
    return null;
  }
}

export const imageService = new ImageService();
